import { useWindowSize } from "src/hooks/useWindowSize";
import { ReviewCarousel } from "../ReviewCarousel";

export const ReviewSection = () => {
  const { width } = useWindowSize();
  return (
    <div
      className="flex flex-col items-center gap-[32px] py-[80px] tablet:px-[32px] desktop:py-[76px] desktop:px-[150px] desktop:gap-[36px]"
      id="review"
    >
      <div className="text-heading-1-mb  w-[244px]  desktop:w-auto text-center desktop:text-left desktop:text-heading-1">
        채권도시 회수 "실제" 사례 (성공 후기)
        {width >= 1440 && (
          <div className="text-body-1 text-center mt-[20px]">
            많은 사람들이 채권도시를 선택 하는 이유
          </div>
        )}
      </div>
      <ReviewCarousel />
      <div
        onClick={() => window.open("https://blog.naver.com/creditncitycm")}
        className="py-[10px] mt-[8px] px-[24px] h-[48px] rounded-[24px] bg-[#2563EB] text-white flex items-center justify-center cursor-pointer"
        id="review_click"
      >
        <span className="text-botton-1"> 실제 성공 사례 확인</span>
      </div>{" "}
    </div>
  );
};
